import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';

import { NavigationBasePage } from '@shared/pages'
import type { TNavigationViewModel, TTicket } from '@shared/models';

@Component({
    'selector': 'app-navigation2Attendance',
    'templateUrl': './navigation2Attendance.page.html',
    'styleUrls': ['./navigation2Attendance.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ]
})
export class Navigation2AttendancePage extends NavigationBasePage implements OnInit {
    public vm: TNavigationViewModel;
    public pickupTickets: any = [];

    constructor( injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_NAVIGATION_PAGE2);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        // this.eventsService.publish(Constants.EVENT_NAV_MORE_MENU_CHANGE);

        this.vm = super.getViewModel() as TNavigationViewModel;
        await this.loadTickets();

        // If there are pickup tickets defined, then we can advance to ticket 3.
        // If there are no pickup tickets defined, then dropoff ticket holders
        // must be present to contine to ticket 3.
        this.vm.step2Complete = (this.vm.pickupTickets.length > 0);
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        try {
            this.resetPopoverMenu();
            this.pushPopoverMenuItem('Show Tickets');
            this.supplyDebugMenuItems();
            // this.pushPopoverMenuItem('Show Tour', 'show-navigation-2-tour');
            // this.moreMenuItemClick(() => this.handleMenuItemClick()); //Copilot suggests this line instead of line 46
            this.moreMenuItemClick(this.handleMenuItemClick);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            throw new Error('navigationPage2.initMoreMenu(); Error = ' + errorMessage);
        }
    }

    private async loadTickets() {
        try {
            await this.uxHelperService.showSpinner('Loading data.');

            this.vm.tickets = this.vm.route.selectedTickets;

            // We are only interested in the customer tickets.  All ending tickets are
            // owned by the dealership and we don't need to display those to take attendance.
            this.pickupTickets = this.vm.tickets.filter((ticket: TTicket) => {
                const isCustomerPickupTicket = (!ticket.fromDealership);
                return isCustomerPickupTicket;
            });

            this.vm.dropoffTickets = this.vm.tickets.filter((ticket: TTicket) => {
                const isCustomerDropoffTicket = (ticket.fromDealership);
                return isCustomerDropoffTicket;
            });

            this.vm.numDropoffsStr = this.vm.dropoffTickets.length + ' Dropoff ';
            this.vm.numDropoffsStr += (this.vm.dropoffTickets.length === 1) ? 'ticket has been defined.' : 'tickets have been defined.';
            this.vm.numAttendees = 0;

            // Set default attendance to Absent.
            this.vm.dropoffTickets.forEach((ticket) => {
                ticket.attendance = false;
                ticket.attendanceStr = 'Absent';
            });
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            throw new Error('navigationPage2.loadTickets(); Error = ' + errorMessage);
        } finally {
            // console .log(this.vm.dropoffTickets);
            await this.uxHelperService.hideSpinner();
        }
    }

    public dropoffTicketsExists() {
        const exists = (this.vm.dropoffTickets && this.vm.dropoffTickets.length > 0);
        return exists;
    }

    public pickupTicketsExists() {
        // const exists = (this.vm.pickupTickets && this.vm.pickupTickets.length > 0);
        const exists = (this.pickupTickets && this.pickupTickets.length > 0);
        return exists;
    }

    public onNextClick() {
        if (this.vm.step2Complete) {
            super.setViewModel(this.vm);
            this.router.navigateByUrl('/navigation/navigation3StartRoute');
        } else {
            const msg = (this.pickupTickets.length === 0) ? 'First select a ticket to dropoff' : '';
            this.uxHelperService.showAlert('Info', msg);
        }
    }

    public onAttendanceChange(ticket: TTicket) {
        ticket.attendanceStr = (ticket.attendance) ? 'Present' : 'Absent';

        const dropoffAndPresentTicketHolders = this.vm.tickets.filter((tix: TTicket) => (tix.attendance));
        this.vm.numAttendees = dropoffAndPresentTicketHolders.length;

        // If there is at least one present rider or at least 1 pickup then okay to advance to the next page.
        this.vm.step2Complete = (dropoffAndPresentTicketHolders.length > 0 || this.pickupTickets.length > 0);
    }
}
